import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>
            {/*Videos*/}
            <VideoComponent id="INT_INT_V002" src={process.env.PUBLIC_URL + `/videos/INT_INT_V002.mp4`}/>
            <VideoComponent id="INT_INT_V003" src={process.env.PUBLIC_URL + `/videos/INT_INT_V003.mp4`}/>


            <VideoComponent id="LAF_LAF_V206" src={process.env.PUBLIC_URL + `/videos/LAF_LAF_V206.mp4`}/>
            <VideoComponent id="LAF_LAF_V207" src={process.env.PUBLIC_URL + `/videos/LAF_LAF_V207.mp4`}/>
            <VideoComponent id="LAF_LAF_V208" src={process.env.PUBLIC_URL + `/videos/LAF_LAF_V208.mp4`}/>
            <VideoComponent id="LAF_LAF_V209" src={process.env.PUBLIC_URL + `/videos/LAF_LAF_V209.mp4`}/>

            <VideoComponent id="TBP_TBP_V237" src={process.env.PUBLIC_URL + `/videos/TBP_TBP_V237.mp4`}/>

            <VideoComponent id="DVE_DVE_V258" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V258.mp4`}/>
            <VideoComponent id="DVE_DVE_V259" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V259.mp4`}/>
            <VideoComponent id="DVE_DVE_V260" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V260.mp4`}/>
            <VideoComponent id="DVE_DVE_V261" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V261.mp4`}/>
            <VideoComponent id="DVE_DVE_V262" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V262.mp4`}/>
            <VideoComponent id="DVE_DVE_V275" src={process.env.PUBLIC_URL + `/videos/DVE_DVE_V275.mp4`}/>

            <VideoComponent id="TAN_TAN_V316" src={process.env.PUBLIC_URL + `/videos/TAN_TAN_V316.mp4`}/>
            <VideoComponent id="TAN_TAN_V332" src={process.env.PUBLIC_URL + `/videos/TAN_TAN_V332.mp4`}/>

            {/*Cineplex videos*/}
            <VideoComponent id="GEN_GEN_V213" src={process.env.PUBLIC_URL + `/videos/GEN_GEN_V213.mp4`}/>
            <VideoComponent id="INT_INT_V150" src={process.env.PUBLIC_URL + `/videos/INT_INT_V150.mp4`}/>
            <VideoComponent id="GEN_GEN_V346" src={process.env.PUBLIC_URL + `/videos/GEN_GEN_V346.mp4`}/>


            {/*Audio*/}
            <VideoComponent id="DVE_DVE_A263" src={process.env.PUBLIC_URL + `/audio/DVE_DVE_A263.mp3`} audio="Y"/>
            <VideoComponent id="DVE_DVE_A264" src={process.env.PUBLIC_URL + `/audio/DVE_DVE_A264.mp3`} audio="Y"/>
            <VideoComponent id="DVE_DVE_A265" src={process.env.PUBLIC_URL + `/audio/DVE_DVE_A265.mp3`} audio="Y"/>
            <VideoComponent id="DVE_DVE_A266" src={process.env.PUBLIC_URL + `/audio/DVE_DVE_A266.mp3`} audio="Y"/>
            <VideoComponent id="DVE_DVE_A267" src={process.env.PUBLIC_URL + `/audio/DVE_DVE_A267.mp3`} audio="Y"/>

        </div>
    )
}

export default VideosComponent;
